import { useMemo } from 'react';
import { usePermissions } from '../hooks/usePermissions';
import { APP_TOOLS } from './appTools';

export function useVisibleTools() {
  const { hasPermission, loading } = usePermissions();

  const tools = useMemo(
    () => (loading ? [] : APP_TOOLS.filter((tool) => hasPermission(tool.permission))),
    [hasPermission, loading]
  );

  return {
    ready: !loading,
    tools,
    canTools: !loading && tools.length > 0
  };
}
